import React from 'react';
import { useStyles } from './styles';
import { Box } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { useHistory } from 'react-router-dom';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { getMortgageLabel, getLoanLabel } from '../../helpers';

export const TransferInfoAlert = (props) => {

  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const handleClose = () => props.closePopup()
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const history = useHistory()

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle } }} onClose={handleClose} open={props?.transferAlertStatus}>
      <Box className={classes.root}>
        <IconButton onClick={handleClose} className={classes.closeIcon}>
          <CancelIcon />
        </IconButton>
        <Box className={classes.cardBody}>
          <Box className={classes.statusContainer}>
            <p className={classes.statusTitle}>
            We would like to inform you that your {getMortgageLabel()?.toLowerCase()} {getLoanLabel()?.toLowerCase()}  has been transferred to a new servicer. As a result, you will no longer be able to make updates to your account information on our portal. If you need to update any information, please contact the new servicer directly.</p>
            <p className={classes.statusTitle}>
            You will only have view rights, which will allow you to access information about your {getLoanLabel()?.toLowerCase()}  balance, payment history, and account details. You can also view/download the available documents in document center as usual before.</p>
            <p className={classes.statusTitle}> New Servicer Contact Information:</p>
            <p className={classes.statusTitle}> {props?.newServicerName}</p>
            { ((props?.newServicerPhone !== null) && (props?.newServicerPhone !== "") && (props?.newServicerPhone !== 'null'))  &&
            <p className={classes.statusTitle}> If you need help or have questions, please don't hesitate to call your new servicer
             at <a href={"tel:" + props?.newServicerPhone}>{props?.newServicerPhone}</a>
            </p>
            }
           
          </Box>
        </Box>
      </Box>
    </Dialog>
  )
}